// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file webauthn_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { SyncUpdate } from "./sync_update_pb";
import { file_sync_update } from "./sync_update_pb";
import type { CredentialType } from "./credential_type_pb";
import { file_credential_type } from "./credential_type_pb";
import type { WebauthnPrfSupportStatus } from "./webauthn_prf_support_status_pb";
import { file_webauthn_prf_support_status } from "./webauthn_prf_support_status_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file webauthn_service.proto.
 */
export const file_webauthn_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_sync_update, file_credential_type, file_webauthn_prf_support_status]);

/**
 * @generated from message domain.RegisterCredentialInitRequest
 */
export type RegisterCredentialInitRequest = Message<"domain.RegisterCredentialInitRequest"> & {
  /**
   * @generated from field: domain.CredentialType credential_type = 1;
   */
  credentialType: CredentialType;
};

/**
 * Describes the message domain.RegisterCredentialInitRequest.
 * Use `create(RegisterCredentialInitRequestSchema)` to create a new message.
 */
export const RegisterCredentialInitRequestSchema: GenMessage<RegisterCredentialInitRequest> = /*@__PURE__*/
  messageDesc(file_webauthn_service, 0);

/**
 * @generated from message domain.RegisterCredentialInitResponse
 */
export type RegisterCredentialInitResponse = Message<"domain.RegisterCredentialInitResponse"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string options_json = 2;
   */
  optionsJson: string;
};

/**
 * Describes the message domain.RegisterCredentialInitResponse.
 * Use `create(RegisterCredentialInitResponseSchema)` to create a new message.
 */
export const RegisterCredentialInitResponseSchema: GenMessage<RegisterCredentialInitResponse> = /*@__PURE__*/
  messageDesc(file_webauthn_service, 1);

/**
 * @generated from message domain.RegisterCredentialForAccountCreationInitRequest
 */
export type RegisterCredentialForAccountCreationInitRequest = Message<"domain.RegisterCredentialForAccountCreationInitRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message domain.RegisterCredentialForAccountCreationInitRequest.
 * Use `create(RegisterCredentialForAccountCreationInitRequestSchema)` to create a new message.
 */
export const RegisterCredentialForAccountCreationInitRequestSchema: GenMessage<RegisterCredentialForAccountCreationInitRequest> = /*@__PURE__*/
  messageDesc(file_webauthn_service, 2);

/**
 * @generated from message domain.RegisterCredentialForAccountCreationInitResponse
 */
export type RegisterCredentialForAccountCreationInitResponse = Message<"domain.RegisterCredentialForAccountCreationInitResponse"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string options_json = 2;
   */
  optionsJson: string;
};

/**
 * Describes the message domain.RegisterCredentialForAccountCreationInitResponse.
 * Use `create(RegisterCredentialForAccountCreationInitResponseSchema)` to create a new message.
 */
export const RegisterCredentialForAccountCreationInitResponseSchema: GenMessage<RegisterCredentialForAccountCreationInitResponse> = /*@__PURE__*/
  messageDesc(file_webauthn_service, 3);

/**
 * @generated from message domain.RegisterCredentialFinishRequest
 */
export type RegisterCredentialFinishRequest = Message<"domain.RegisterCredentialFinishRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string response_json = 2;
   */
  responseJson: string;

  /**
   * @generated from field: domain.WebauthnPrfSupportStatus prf_support_status = 3;
   */
  prfSupportStatus: WebauthnPrfSupportStatus;
};

/**
 * Describes the message domain.RegisterCredentialFinishRequest.
 * Use `create(RegisterCredentialFinishRequestSchema)` to create a new message.
 */
export const RegisterCredentialFinishRequestSchema: GenMessage<RegisterCredentialFinishRequest> = /*@__PURE__*/
  messageDesc(file_webauthn_service, 4);

/**
 * @generated from message domain.RegisterCredentialFinishResponse
 */
export type RegisterCredentialFinishResponse = Message<"domain.RegisterCredentialFinishResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.RegisterCredentialFinishResponse.
 * Use `create(RegisterCredentialFinishResponseSchema)` to create a new message.
 */
export const RegisterCredentialFinishResponseSchema: GenMessage<RegisterCredentialFinishResponse> = /*@__PURE__*/
  messageDesc(file_webauthn_service, 5);

/**
 * @generated from message domain.UnlockSessionInitRequest
 */
export type UnlockSessionInitRequest = Message<"domain.UnlockSessionInitRequest"> & {
};

/**
 * Describes the message domain.UnlockSessionInitRequest.
 * Use `create(UnlockSessionInitRequestSchema)` to create a new message.
 */
export const UnlockSessionInitRequestSchema: GenMessage<UnlockSessionInitRequest> = /*@__PURE__*/
  messageDesc(file_webauthn_service, 6);

/**
 * @generated from message domain.UnlockSessionInitResponse
 */
export type UnlockSessionInitResponse = Message<"domain.UnlockSessionInitResponse"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string options_json = 2;
   */
  optionsJson: string;
};

/**
 * Describes the message domain.UnlockSessionInitResponse.
 * Use `create(UnlockSessionInitResponseSchema)` to create a new message.
 */
export const UnlockSessionInitResponseSchema: GenMessage<UnlockSessionInitResponse> = /*@__PURE__*/
  messageDesc(file_webauthn_service, 7);

/**
 * @generated from message domain.UnlockSessionFinishRequest
 */
export type UnlockSessionFinishRequest = Message<"domain.UnlockSessionFinishRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string response_json = 2;
   */
  responseJson: string;

  /**
   * @generated from field: google.protobuf.Timestamp max_expires_at = 3;
   */
  maxExpiresAt?: Timestamp | undefined;
};

/**
 * Describes the message domain.UnlockSessionFinishRequest.
 * Use `create(UnlockSessionFinishRequestSchema)` to create a new message.
 */
export const UnlockSessionFinishRequestSchema: GenMessage<UnlockSessionFinishRequest> = /*@__PURE__*/
  messageDesc(file_webauthn_service, 8);

/**
 * @generated from message domain.UnlockSessionFinishResponse
 */
export type UnlockSessionFinishResponse = Message<"domain.UnlockSessionFinishResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.UnlockSessionFinishResponse.
 * Use `create(UnlockSessionFinishResponseSchema)` to create a new message.
 */
export const UnlockSessionFinishResponseSchema: GenMessage<UnlockSessionFinishResponse> = /*@__PURE__*/
  messageDesc(file_webauthn_service, 9);

/**
 * @generated from message domain.DeleteCredentialsRequest
 */
export type DeleteCredentialsRequest = Message<"domain.DeleteCredentialsRequest"> & {
  /**
   * @generated from field: repeated string webauthn_ids = 1;
   */
  webauthnIds: string[];
};

/**
 * Describes the message domain.DeleteCredentialsRequest.
 * Use `create(DeleteCredentialsRequestSchema)` to create a new message.
 */
export const DeleteCredentialsRequestSchema: GenMessage<DeleteCredentialsRequest> = /*@__PURE__*/
  messageDesc(file_webauthn_service, 10);

/**
 * @generated from message domain.DeleteCredentialsResponse
 */
export type DeleteCredentialsResponse = Message<"domain.DeleteCredentialsResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.DeleteCredentialsResponse.
 * Use `create(DeleteCredentialsResponseSchema)` to create a new message.
 */
export const DeleteCredentialsResponseSchema: GenMessage<DeleteCredentialsResponse> = /*@__PURE__*/
  messageDesc(file_webauthn_service, 11);

/**
 * WebauthnService provides methods for management and use of webauthn credentials.
 *
 * @generated from service domain.WebauthnService
 */
export const WebauthnService: GenService<{
  /**
   * errors:
   * - BadRequest (10400): if an unknown credential type is given
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - SessionNotUnlocked (20431)
   * - Internal (10500)
   *
   * @generated from rpc domain.WebauthnService.RegisterCredentialInit
   */
  registerCredentialInit: {
    methodKind: "unary";
    input: typeof RegisterCredentialInitRequestSchema;
    output: typeof RegisterCredentialInitResponseSchema;
  },
  /**
   * errors:
   * - InvalidEmail (20101)
   * - Internal (10500)
   *
   * @generated from rpc domain.WebauthnService.RegisterCredentialForAccountCreationInit
   */
  registerCredentialForAccountCreationInit: {
    methodKind: "unary";
    input: typeof RegisterCredentialForAccountCreationInitRequestSchema;
    output: typeof RegisterCredentialForAccountCreationInitResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - SessionNotUnlocked (20431)
   * - WebauthnValidateError (80400): there is a cryptographic error with the response
   * - WebauthnDataError (80401): there is a parsing error with the response
   * - WebauthnInvalidTransport (80403): credential had an invalid transport (for its type)
   * - WebauthnRequestNotFound (80402): the request_id was not found, or timed out
   * - Internal (10500)
   *
   * @generated from rpc domain.WebauthnService.RegisterCredentialFinish
   */
  registerCredentialFinish: {
    methodKind: "unary";
    input: typeof RegisterCredentialFinishRequestSchema;
    output: typeof RegisterCredentialFinishResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - SessionNotUnlocked (20431): session can't be unlocked due to missing encrypted_session_unlock
   * - MissingWebauthnCredential (80404): if no webauthn credentials are registered
   * - Internal (10500)
   *
   * @generated from rpc domain.WebauthnService.UnlockSessionInit
   */
  unlockSessionInit: {
    methodKind: "unary";
    input: typeof UnlockSessionInitRequestSchema;
    output: typeof UnlockSessionInitResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - InvalidTimeout (20420): expires_at is already expired
   * - WebauthnValidateError (80400): there is a cryptographic error with the response
   * - WebauthnDataError (80401): there is a parsing error with the response
   * - WebauthnRequestNotFound (80402): the request_id was not found, or timed out
   * - Internal (10500)
   *
   * @generated from rpc domain.WebauthnService.UnlockSessionFinish
   */
  unlockSessionFinish: {
    methodKind: "unary";
    input: typeof UnlockSessionFinishRequestSchema;
    output: typeof UnlockSessionFinishResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - Internal (10500)
   *
   * @generated from rpc domain.WebauthnService.DeleteCredentials
   */
  deleteCredentials: {
    methodKind: "unary";
    input: typeof DeleteCredentialsRequestSchema;
    output: typeof DeleteCredentialsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_webauthn_service, 0);

